import type { ReactNode } from 'react'
import { cn } from '@/lib/cn'

/** Max-width per mode; "full" spans the whole content area (e.g. the board). */
const WIDTHS = {
  narrow: 'max-w-3xl',
  wide: 'max-w-7xl',
  full: '',
} as const

/**
 * Shared page wrapper so every screen uses the same padding and one of a few
 * consistent content widths instead of hardcoding `p-6 max-w-*` ad hoc.
 */
export default function PageContainer({
  width = 'narrow',
  className,
  children,
}: {
  width?: keyof typeof WIDTHS
  className?: string
  children: ReactNode
}) {
  return (
    <div className={cn('p-4 md:p-6', width !== 'full' && `${WIDTHS[width]} mx-auto`, className)}>
      {children}
    </div>
  )
}
